import { createAsyncThunk } from '@reduxjs/toolkit';
import { AdminsAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import { ADMINS_LIST_SLICE_NAME } from './models';
import {
  ICreateAdminDTO,
  IGetAdminsListDTO,
  IAdmin,
  IAdminsListResponse,
  IUpdateAdminDTO,
} from '@/models/admins.model';

export const getAdminsList = createAsyncThunk<
  IAdminsListResponse,
  IGetAdminsListDTO,
  { serializedErrorType: IApiError }
>(
  `${ADMINS_LIST_SLICE_NAME}/getAdminsList`,
  async (data) => {
    const response = await AdminsAPI.getAdminsList(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const getAdminDetails = createAsyncThunk<IAdmin, string, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/getAdminDetails`,
  async (id) => {
    const response = await AdminsAPI.getAdminDetails(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deleteAdmin = createAsyncThunk<IAdmin, string, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/deleteAdmin`,
  async (id) => {
    const response = await AdminsAPI.deleteAdmin(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateAdminDetails = createAsyncThunk<IAdmin, IUpdateAdminDTO, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/updateAdminDetails`,
  async (data) => {
    const response = await AdminsAPI.updateAdminDetails(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const createAdmin = createAsyncThunk<IAdmin, ICreateAdminDTO, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/createAdmin`,
  async (data) => {
    const response = await AdminsAPI.createAdmin(data);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const activateAdmin = createAsyncThunk<IAdmin, string, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/activateAdmin`,
  async (id) => {
    const response = await AdminsAPI.activateAdmin(id);
    return response.data;
  },
  { serializeError: formatApiError },
);

export const deactivateAdmin = createAsyncThunk<IAdmin, string, { serializedErrorType: IApiError }>(
  `${ADMINS_LIST_SLICE_NAME}/deactivateAdmin`,
  async (id) => {
    const response = await AdminsAPI.deactivateAdmin(id);
    return response.data;
  },
  { serializeError: formatApiError },
);
